import { Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import * as ApexCharts from 'apexcharts';
import * as chartSettings from './chartSettings';
import { NavService } from 'src/app/_services/nav.service';
import { DashboardService } from 'src/app/_services/dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePeriodService } from 'src/app/_services/date-period.service';
import { AuthService } from 'src/app/_services/auth.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupDeleteComponent } from '../informes/descargas/delete-popup.component';
import { Router } from '@angular/router';
import { LicenseService } from 'src/app/_services/license.service';
import { SyncService } from 'src/app/_services/sync.service';
import { CompanyService } from 'src/app/_services/company.service';
import { AlertConfigModalComponent, AlertKpiConfig } from './alert-config-modal/alert-config-modal.component';
import { ExternalDeliveryConfigModalComponent, ExternalDeliveryKpiConfig } from './external-delivery-config-modal/external-delivery-config-modal.component';
import { TaggingKpiConfigModalComponent, TaggingKpiConfig } from './tagging-kpi-config-modal/tagging-kpi-config-modal.component';

@Component({
  selector: 'app-Index',
  templateUrl: './Index.component.html',
  styleUrls: ['./Index.component.css'],
})
export class IndexComponent implements OnInit, OnDestroy {
  periodDate: any;

  sensitiveInformationAlerts: any;
  topDeniedUsers: any;
  getTopCopilotUsers: any;
  topCopilotInteractionsByDepartment: any;

  daysLabel: any;

  datePeriod: { dateStart; dateEnd };

  tooltipsVisible: { [key: string]: boolean } = {};
  timeoutIds: { [key: string]: any } = {};

  isLoading1: boolean = true;
  isLoading2: boolean = true;
  isLoading3: boolean = true;
  isLoading4: boolean = true;
  isLoading5: boolean = true;
  isLoading6: boolean = true;
  isLoading7: boolean = true;
  isLoading8: boolean = true;
  isLoading9: boolean = true;
  isLoading10: boolean = true;

  chart3Empty: boolean = false;
  chart4Empty: boolean = false;
  chart5Empty: boolean = true;
  chart7Empty: boolean = false;
  chart8Empty: boolean = false;
  chart9Empty: boolean = false;
  chart10Empty: boolean = false;

  showChart5: boolean = false;

  securityBreachesCount: number;
  documentLabeledCount: number;
  identifiedAlertsCount: number;
  taggingUsersCount: number;
  copilotInteractionsCount: number;
  taggingChampion: any;
  departamentLabel: any;
  labelsByDept: any;

  chartInstances: ApexCharts[] = [];

  userFullName: string;
  userDepartment: string;
  lastSync: string;

  isCompanyAdmin: boolean;
  canSync: boolean = false;

  isExpired: boolean = false;
  isExceeded: boolean = false;
  showINCIBEFooter: boolean = false;

  loadingSecurityBreachesCount: boolean;
  loadingDocumentLabeledCount: boolean;
  loadingIdentifiedAlertsCount: boolean;
  loadingTaggingUsersCount: boolean;
  loadingCopilotInteractionsCount: boolean;

  alertKpiConfig: AlertKpiConfig = { minOccurrences: 0, selectedTypes: [] };
  externalDeliveryKpiConfig: ExternalDeliveryKpiConfig = { selectedTypes: [], excludedDomains: [] };
  taggingKpiConfig: TaggingKpiConfig = { selectedTypes: ['Manual'] };
  private currentCompanyId: number | null = null;
  private configsLoaded = false;
  private dataSubscriptions = new Subscription();
  private lifetimeSubscriptions = new Subscription();

  private cancelDataRequests() {
    this.dataSubscriptions.unsubscribe();
    this.dataSubscriptions = new Subscription();
  }

  private loadAlertConfig(companyId: number) {
    this.currentCompanyId = companyId;
    this.configsLoaded = false;
    this.alertKpiConfig = { minOccurrences: 0, selectedTypes: [] };
    this.externalDeliveryKpiConfig = { selectedTypes: [], excludedDomains: [] };
    this.taggingKpiConfig = { selectedTypes: ['Manual'] };

    this.lifetimeSubscriptions.add(
      forkJoin([
        this.dashboardService.getAlertKpiConfig(),
        this.dashboardService.getExternalDeliveryKpiConfig(),
        this.dashboardService.getTaggingUsersKpiConfig()
      ]).subscribe({
        next: ([alertRes, edRes, taggingRes]) => {
          if (alertRes.body) this.alertKpiConfig = alertRes.body;
          if (edRes.body) this.externalDeliveryKpiConfig = edRes.body;
          if (taggingRes.body?.selectedTypes?.length) this.taggingKpiConfig = taggingRes.body;
          this.configsLoaded = true;
          if (this.datePeriod) {
            this.refreshFilteredKpiCounts();
          }
        }
      })
    );
  }

  private refreshFilteredKpiCounts(includeTaggingUsers = true) {
    this.loadingIdentifiedAlertsCount = true;
    this.loadingSecurityBreachesCount = true;
    if (includeTaggingUsers) {
      this.loadingTaggingUsersCount = true;
    }
    this.dataSubscriptions.add(
      this.dashboardService
        .getIdentifiedAlertsCount(
          this.datePeriod,
          this.alertKpiConfig.minOccurrences > 0 ? this.alertKpiConfig.minOccurrences : undefined,
          this.alertKpiConfig.selectedTypes?.length ? this.alertKpiConfig.selectedTypes : undefined
        )
        .subscribe(res => {
          this.loadingIdentifiedAlertsCount = false;
          this.identifiedAlertsCount = res.body.count;
        })
    );
    this.dataSubscriptions.add(
      this.dashboardService
        .getSecurityBreachesCount(
          this.datePeriod,
          this.externalDeliveryKpiConfig.selectedTypes?.length ? this.externalDeliveryKpiConfig.selectedTypes : undefined,
          this.externalDeliveryKpiConfig.excludedDomains?.length ? this.externalDeliveryKpiConfig.excludedDomains : undefined
        )
        .subscribe(res => {
          this.loadingSecurityBreachesCount = false;
          this.securityBreachesCount = res.body;
        })
    );
    if (includeTaggingUsers) {
      this.dataSubscriptions.add(
        this.dashboardService
          .getTaggingUsersCount(this.datePeriod, this.taggingKpiConfig.selectedTypes)
          .subscribe(res => {
            this.loadingTaggingUsersCount = false;
            this.taggingUsersCount = res.body.count;
            this.isExceeded = !!res.body.isLicenseExceeded;
          })
      );
    }
  }

  get taggingKpiActive(): boolean {
    const types = this.taggingKpiConfig.selectedTypes ?? [];
    return !(types.length === 1 && types[0] === 'Manual');
  }

  openTaggingKpiConfig(event: MouseEvent) {
    event.stopPropagation();
    const modal = this.modalService.open(TaggingKpiConfigModalComponent, { centered: true, size: 'md' });
    modal.componentInstance.currentConfig = { selectedTypes: [...(this.taggingKpiConfig.selectedTypes ?? ['Manual'])] };
    modal.result.then((config: TaggingKpiConfig) => {
      this.taggingKpiConfig = config;
      this.dashboardService.saveTaggingUsersKpiConfig(config).subscribe();
      this.loadingTaggingUsersCount = true;
      this.loadingDocumentLabeledCount = true;
      this.dashboardService
        .getTaggingDashboardKpis(this.datePeriod, config.selectedTypes)
        .subscribe((res) => {
          const body = res.body || {};
          this.loadingTaggingUsersCount = false;
          this.loadingDocumentLabeledCount = false;
          this.documentLabeledCount = body.labeledCount ?? this.documentLabeledCount;
          this.taggingUsersCount = body.taggingUsersCount ?? 0;
          this.isExceeded = !!body.isLicenseExceeded;
          this.showChart5 = false;
          if (!body.championCount && !body.championUser) {
            this.chart5Empty = true;
          } else {
            this.chart5Empty = false;
            this.showChart5 = true;
            this.taggingChampion = { user: body.championUser, count: body.championCount };
          }
        });
    }).catch(() => {});
  }

  protected ngbModalRef: NgbModalRef;

  constructor(
    private appComponent: AppComponent,
    private navService: NavService,
    public dashboardService: DashboardService,
    private translateService: TranslateService,
    private elementRef: ElementRef,
    private datePeriodService: DatePeriodService,
    public authService: AuthService,
    private modalService: NgbModal,
    public syncService: SyncService,
    public router: Router,
    public licenseService: LicenseService,
    private companyService: CompanyService
  ) {}

  ngOnInit() {
    this.appComponent.setTitle('Home');
    this.selectedNavItem(null);
    this.lifetimeSubscriptions.add(
      this.companyService.getByUser().subscribe((res: any) => {
        this.showINCIBEFooter = res?.body?.id === 1073;
      })
    );
    this.lifetimeSubscriptions.add(
      this.authService
        .getAccount(window.localStorage.getItem('id'))
        .subscribe((res) => {
          this.userFullName = res?.userlist?.name;
          this.userDepartment = res?.userlist?.department;
          if (res?.userlist?.idCompany) this.loadAlertConfig(res.userlist.idCompany);
          this.lifetimeSubscriptions.add(
            this.licenseService
              .isExpired(res?.userlist?.idCompany)
              .subscribe((response) => {
                this.isExpired = !!response;
              })
          );
        })
    );
    this.lifetimeSubscriptions.add(
      this.syncService.getLastSync().subscribe((res) => {
        this.lastSync = this.formatDate(res?.body?.lastModifiedDate);
      })
    );
    this.lifetimeSubscriptions.add(
      this.syncService.canSync().subscribe((res) => {
        this.canSync = !res.body;
      })
    );
    this.lifetimeSubscriptions.add(
      this.authService.isAdmin().subscribe((res) => {
        this.isCompanyAdmin = !!res;
      })
    );
    this.lifetimeSubscriptions.add(
      this.translateService.onLangChange.subscribe((res) => {
      this.daysLabel = this.translateService.instant('home.hello');
      const chart1 = document.getElementById('transactionsMonthly').children[0];
      const chart2 = document.getElementById('orderStatus').children[0];
      const chart3 = document.getElementById('labelsByDept').children[0];

      if (chart1 && chart1.id === 'noData') {
        document.getElementById('transactionsMonthly').innerHTML = '';
        document.getElementById(
          'transactionsMonthly'
        ).innerHTML = `<div id="noData" style="width: 100%; height: 320px; display: grid; place-content: center;">${this.translateService.instant(
          'noData'
        )}</div>`;
      }

      if (chart2 && chart2.id === 'noData') {
        document.getElementById('orderStatus').innerHTML = '';
        document.getElementById(
          'orderStatus'
        ).innerHTML = `<div id="noData" style="width: 100%; height: 340px; display: grid; place-content: center;">${this.translateService.instant(
          'noData'
        )}</div>`;
      }

      if (chart2 && chart2.id === 'noData') {
        document.getElementById('orderStatus').innerHTML = '';
        document.getElementById(
          'orderStatus'
        ).innerHTML = `<div id="noData" style="width: 100%; height: 340px; display: grid; place-content: center;">${this.translateService.instant(
          'noData'
        )}</div>`;
      }

      if (chart3 && chart3.id === 'noData') {
        document.getElementById('labelsByDept').innerHTML = '';
        document.getElementById(
          'labelsByDept'
        ).innerHTML = `<div id="noData" style="width: 100%; height: 350px; display: grid; place-content: center;">${this.translateService.instant(
          'noData'
        )}</div>`;
      }
      })
    );
    this.lifetimeSubscriptions.add(
      this.datePeriodService.dateRange$.subscribe(() => {
        this.chartInstances.forEach((chart) => {
          chart.destroy(); // Destruye la instancia del gráfico
        });
        this.chartInstances = []; // Limpia el array de instancias de gráficos
        document.getElementById('transactionsMonthly').innerHTML = '';
        document.getElementById('orderStatus').innerHTML = '';
        document.getElementById('labelsByDept').innerHTML = '';
        document.getElementById('aiInteractionsByWorkload').innerHTML = '';
        this.chart3Empty = false;
        this.chart4Empty = false;
        this.chart5Empty = false;
        this.chart7Empty = false;
        this.chart10Empty = false;
        this.clearCharts();
        const datePeriod = this.datePeriodService.getFormatedDate();

        this.datePeriod = datePeriod;
        this.getData();
      })
    );
  }

  ngOnDestroy() {
    this.cancelDataRequests();
    this.lifetimeSubscriptions.unsubscribe();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  get alertKpiActive(): boolean {
    return this.alertKpiConfig.minOccurrences > 0 || this.alertKpiConfig.selectedTypes?.length > 0;
  }

  get externalDeliveryKpiActive(): boolean {
    return (this.externalDeliveryKpiConfig.selectedTypes?.length > 0) || (this.externalDeliveryKpiConfig.excludedDomains?.length > 0);
  }

  openExternalDeliveryConfig(event: MouseEvent) {
    event.stopPropagation();
    const modal = this.modalService.open(ExternalDeliveryConfigModalComponent, { centered: true, size: 'md' });
    modal.componentInstance.currentConfig = {
      selectedTypes: [...(this.externalDeliveryKpiConfig.selectedTypes ?? [])],
      excludedDomains: [...(this.externalDeliveryKpiConfig.excludedDomains ?? [])],
    };
    modal.result.then((config: ExternalDeliveryKpiConfig) => {
      this.externalDeliveryKpiConfig = config;
      this.dashboardService.saveExternalDeliveryKpiConfig(config).subscribe();
      this.loadingSecurityBreachesCount = true;
      this.dashboardService
        .getSecurityBreachesCount(
          this.datePeriod,
          config.selectedTypes?.length ? config.selectedTypes : undefined,
          config.excludedDomains?.length ? config.excludedDomains : undefined
        )
        .subscribe((res) => {
          this.loadingSecurityBreachesCount = false;
          this.securityBreachesCount = res.body;
        });
    }).catch(() => {});
  }

  openAlertConfig(event: MouseEvent) {
    event.stopPropagation();
    const modal = this.modalService.open(AlertConfigModalComponent, { centered: true, size: 'md' });
    modal.componentInstance.currentConfig = { ...this.alertKpiConfig };
    modal.result.then((config: AlertKpiConfig) => {
      this.alertKpiConfig = config;
      this.dashboardService.saveAlertKpiConfig(config).subscribe();
      this.loadingIdentifiedAlertsCount = true;
      this.dashboardService
        .getIdentifiedAlertsCount(
          this.datePeriod,
          config.minOccurrences > 0 ? config.minOccurrences : undefined,
          config.selectedTypes?.length ? config.selectedTypes : undefined
        )
        .subscribe((res) => {
          this.loadingIdentifiedAlertsCount = false;
          this.identifiedAlertsCount = res.body.count;
        });
    }).catch(() => {});
  }

  formatLabel(label) {
    return label.replace(/ /g, '\n');
  }

  getData() {
    this.cancelDataRequests();
    this.clearCharts();
    this.isLoading1 = true;
    this.isLoading2 = true;
    this.isLoading3 = true;
    this.isLoading4 = true;
    this.isLoading5 = true;
    this.isLoading6 = true;
    this.isLoading7 = true;
    this.isLoading8 = true;
    this.isLoading9 = true;
    this.isLoading10 = true;
    this.loadingDocumentLabeledCount = true;
    this.loadingIdentifiedAlertsCount = true;
    this.loadingSecurityBreachesCount = true;
    this.loadingTaggingUsersCount = true;
    this.loadingCopilotInteractionsCount = true;

    // KPI cards first (above the fold) so the concurrency queue prioritizes them.
    this.dataSubscriptions.add(
      this.dashboardService
        .getTaggingDashboardKpis(this.datePeriod, this.taggingKpiConfig.selectedTypes)
        .subscribe((res) => {
          const body = res.body || {};
          this.loadingDocumentLabeledCount = false;
          this.documentLabeledCount = body.labeledCount ?? 0;
          this.loadingTaggingUsersCount = false;
          this.taggingUsersCount = body.taggingUsersCount ?? 0;
          this.isExceeded = !!body.isLicenseExceeded;
          this.showChart5 = false;
          if (!body.championCount && !body.championUser) {
            this.chart5Empty = true;
          } else {
            this.chart5Empty = false;
            this.showChart5 = true;
            this.taggingChampion = { user: body.championUser, count: body.championCount };
          }
        })
    );
    this.dataSubscriptions.add(
      this.dashboardService.getAiDashboardKpis(this.datePeriod).subscribe((res) => {
        const body = res.body || {};
        this.loadingCopilotInteractionsCount = false;
        this.copilotInteractionsCount = body.interactionCount ?? 0;

        const topUsers = body.topUsers || [];
        if (topUsers.length === 0) {
          this.getTopCopilotUsers = [];
          this.chart8Empty = true;
          this.isLoading8 = false;
        } else {
          this.getTopCopilotUsers = topUsers.slice(0, 5);
          this.chart8Empty = false;
          this.isLoading8 = false;
        }

        const byDept = body.interactionsByDepartment || [];
        if (byDept.length === 0) {
          const deptEl = document.getElementById('topCopilotInteractionsByDepartment');
          if (deptEl) {
            deptEl.innerHTML = '';
          }
          this.isLoading9 = false;
        } else {
          const deptSeries = byDept
            .filter((label) => label.department?.trim())
            .slice(0, 10)
            .map((label) => ({ name: label.department, data: [label.total ?? label.count] }));

          const deptOptions = {
            series: deptSeries,
            chart: { type: 'bar', height: 300, toolbar: { show: false } },
            plotOptions: { bar: { horizontal: false, columnWidth: '60%', endingShape: 'rounded' } },
            dataLabels: { enabled: false },
            stroke: { show: true, width: 2, colors: ['transparent'] },
            xaxis: { type: 'category', categories: [''], convertedCatToNumeric: false },
            fill: { opacity: 1 },
            legend: {
              position: 'bottom',
              horizontalAlign: 'center',
              fontSize: '9px',
              fontFamily: 'Poppins, sans-serif',
              itemMargin: { horizontal: 4, vertical: 2 },
            },
            tooltip: { theme: 'dark' },
          };

          const chart = new ApexCharts(
            document.querySelector('#topCopilotInteractionsByDepartment'),
            deptOptions
          );
          chart.render();
          this.chartInstances.push(chart);
          this.chart9Empty = false;
          this.isLoading9 = false;
        }

        const byWorkload = body.interactionsByWorkload || [];
        if (!byWorkload.length) {
          this.chart10Empty = true;
          this.isLoading10 = false;
        } else {
          this.chart10Empty = false;
          const workloadEl = document.getElementById('aiInteractionsByWorkload');
          if (workloadEl) {
            workloadEl.innerHTML = '';
          }

          const labels = byWorkload.map((item) => item.workload);
          const series = byWorkload.map((item) => item.count);

          const donutOptions = {
            series,
            labels,
            chart: {
              type: 'donut',
              height: 300,
              fontFamily: 'Poppins, sans-serif',
              toolbar: { show: false },
            },
            colors: ['#4456b9', '#009688', '#e2a03f', '#e7515a', '#5c1ac3', '#2196f3', '#ff9800', '#4caf50', '#9c27b0', '#f44336'],
            plotOptions: {
              pie: {
                donut: {
                  size: '55%',
                  labels: { show: false },
                },
              },
            },
            dataLabels: { enabled: false },
            legend: {
              position: 'bottom',
              horizontalAlign: 'center',
              fontSize: '11px',
              fontFamily: 'Poppins, sans-serif',
              itemMargin: { horizontal: 6, vertical: 3 },
            },
            tooltip: {
              theme: 'dark',
              y: { formatter: (val) => val.toLocaleString() },
            },
          };

          const chartDonut = new ApexCharts(
            document.querySelector('#aiInteractionsByWorkload'),
            donutOptions
          );
          this.chartInstances.push(chartDonut);
          chartDonut.render();
          this.isLoading10 = false;
        }
      })
    );
    if (this.configsLoaded) {
      // Tagging KPIs already loaded above with current config; only refresh alert/security filters.
      this.refreshFilteredKpiCounts(false);
    }

    // Charts and tops after KPIs (FIFO queue).
    this.dataSubscriptions.add(
      this.dashboardService
        .getInformationGraphsByCompany(this.datePeriod)
        .subscribe((res) => {
          if (res.body.sensData.length === 0) {
            document.getElementById(
              'transactionsMonthly'
            ).innerHTML = `<div id="noData" style="width: 100%; height: 320px; display: grid; place-content: center;">${this.translateService.instant(
              'noData'
            )}</div>`;
            this.isLoading1 = false;
            return;
          }
          document.getElementById('transactionsMonthly').innerHTML = '';
          chartSettings.options1.labels = res.body.sensPeriod;
          chartSettings.options1.series = res.body.sensData;
          chartSettings.options1.title.text = '';

          let maxValue = Number.NEGATIVE_INFINITY;

          res.body.sensData.forEach((item) => {
            const maxInItem = Math.max(...item.data);
            if (maxInItem > maxValue) {
              maxValue = maxInItem;
            }
          });
          maxValue += 1000;
          chartSettings.options1.yaxis.max = maxValue;
          const chart1 = new ApexCharts(
            document.querySelector('#transactionsMonthly'),
            chartSettings.options1
          );
          this.chartInstances.push(chart1);
          chartSettings.options1.yaxis[0].max = maxValue;
          chart1.render();
          this.isLoading1 = false;
        })
    );
    this.dataSubscriptions.add(
      this.dashboardService
        .getLabelsGraphByCompany(this.datePeriod)
        .subscribe((res) => {
          if (res.body.data.length === 0) {
            document.getElementById(
              'orderStatus'
            ).innerHTML = `<div id="noData" style="width: 100%; height: 340px; display: grid; place-content: center;">${this.translateService.instant(
              'noData'
            )}</div>`;
            this.isLoading2 = false;
            return;
          }
          document.getElementById('orderStatus').innerHTML = '';

          chartSettings.options.series = res.body?.data?.map((label) => {
            return {
              name: label.name,
              data: [label.count],
            };
          });

          const chart = new ApexCharts(
            document.querySelector('#orderStatus'),
            chartSettings.options
          );
          chart.render();
          this.chartInstances.push(chart);
          this.isLoading2 = false;
        })
    );
    this.dataSubscriptions.add(
      this.dashboardService
        .getTopIncidentsUsersByCompany(this.datePeriod)
        .subscribe((res) => {
          if (res.body.length === 0) {
            this.chart4Empty = true;
            this.isLoading4 = false;
            return;
          }
          this.chart4Empty = false;
          this.isLoading4 = true;
          this.sensitiveInformationAlerts = res.body?.slice(0, 3);
          this.isLoading4 = false;
        })
    );
    this.dataSubscriptions.add(
      this.dashboardService
        .getTopDeniedUsersByCompany(this.datePeriod)
        .subscribe((res) => {
          if (res.body.length === 0) {
            this.chart3Empty = true;
            this.isLoading3 = false;
            return;
          }
          this.topDeniedUsers = res.body?.slice(0, 6);
          this.chart3Empty = false;
          this.isLoading3 = false;
        })
    );
    this.dataSubscriptions.add(
      this.dashboardService
        .getDepartamentLabel(this.datePeriod)
        .subscribe((res) => {
          if (
            res.body.length === 0 ||
            (res.body[0].department === 'Others' && res.body[0].count === 0)
          ) {
            this.chart7Empty = true;
            this.isLoading5 = false;
            return;
          }
          this.chart7Empty = false;
          this.departamentLabel = res.body.filter(
            (department) => department.department !== 'Others'
          );
          this.isLoading5 = false;
        })
    );
    this.dataSubscriptions.add(
      this.dashboardService
        .getTopLabelsByDept(this.datePeriod)
        .subscribe((res) => {
          if (res.body.length === 0) {
            document.getElementById(
              'labelsByDept'
            ).innerHTML = `<div id="noData" style="width: 100%; height: 350px; display: grid; place-content: center;">${this.translateService.instant(
              'noData'
            )}</div>`;
            this.isLoading6 = false;
            return;
          }
          document.getElementById('labelsByDept').innerHTML = '';

          this.labelsByDept = res.body;

          this.labelsByDept = this.labelsByDept
            .map((dept) => {
              return {
                ...dept,
                totalCount: dept.labelsCounts.reduce(
                  (acc, label) => acc + label.count,
                  0
                ),
              };
            })
            .sort((a, b) => b.totalCount - a.totalCount)
            .slice(0, 4);

          this.labelsByDept.forEach((item) => {
            item.labelsCounts = item.labelsCounts
              .sort((a, b) => b.count - a.count)
              .slice(0, 4);
          });

          let allCategories = this.labelsByDept.flatMap((dept) =>
            dept.labelsCounts.map((label) => label.name)
          );
          let uniqueCategories = [...new Set(allCategories)];

          let seriesData = this.labelsByDept.map((item) => {
            let data = uniqueCategories.map((category) => {
              let label = item.labelsCounts.find(
                (label) => label.name === category
              );
              return label ? label.count : 0;
            });

            return {
              name: item.department,
              data: data,
            };
          });

          let optionsLabelsByDept = {
            series: seriesData,
            chart: {
              type: 'bar',
              height: 400,
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent'],
            },
            xaxis: {
              categories: uniqueCategories,
              labels: {
                rotate: 0,
                style: {
                  fontSize: '8px',
                },
                formatter: function (val) {
                  return val?.toUpperCase();
                },
              },
            },
            legend: {
              position: 'bottom',
              horizontalAlign: 'center',
              offsetY: 12,
              fontSize: '13px',
              fontFamily: 'Poppins, sans-serif',
              markers: {
                width: 10,
                height: 10,
                strokeWidth: 0,
                strokeColor: '#fff',
                fillColors: undefined,
                radius: 12,
                onClick: undefined,
                offsetX: 0,
                offsetY: 0,
              },
              itemMargin: {
                horizontal: 10,
                vertical: 5,
              },
            },
            fill: {
              opacity: 1,
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          };

          const d_2C_1 = new ApexCharts(
            document.querySelector('#labelsByDept'),
            optionsLabelsByDept
          );
          this.chartInstances.push(d_2C_1);
          d_2C_1.render();

          this.isLoading6 = false;
        })
    );
  }

  toggleTooltip(id: string) {
    this.tooltipsVisible[id] = !this.tooltipsVisible[id];

    if (this.tooltipsVisible[id]) {
      this.timeoutIds[id] = setTimeout(() => {
        this.closeTooltip(id);
      }, 4000);
    } else {
      if (this.timeoutIds[id]) {
        clearTimeout(this.timeoutIds[id]);
        delete this.timeoutIds[id];
      }
    }
  }

  closeTooltip(id: string) {
    this.tooltipsVisible[id] = false;
    if (this.timeoutIds[id]) {
      clearTimeout(this.timeoutIds[id]);
      delete this.timeoutIds[id];
    }
  }

  @HostListener('document:click', ['$event'])
  closeTooltips(event: Event) {
    let close = true;
    for (const id of Object.keys(this.tooltipsVisible)) {
      const tooltipElement = this.elementRef.nativeElement.querySelector(
        `[data-tooltip="${id}"]`
      );

      if (tooltipElement && tooltipElement.contains(event.target as Node)) {
        close = false;
        break;
      }
    }
    if (close) {
      this.tooltipsVisible = {};
      for (const id of Object.keys(this.timeoutIds)) {
        clearTimeout(this.timeoutIds[id]);
      }
      this.timeoutIds = {};
    }
  }

  // Código para el gráfico de DepartamentLabel
  getIssueClass(index: number) {
    return `font-12 dynamic-color-${index}`;
  }

  getProgressBarClass(index: number) {
    return `bg-gradient-${this.getColorClass(index)}`;
  }

  getColorClass(index: number) {
    return `dynamic-color-${index}`;
  }

  getSpanClass(index: number) {
    return `dynamic-color-${index}`;
  }

  calculateWidth(count: number, index: number) {
    const totalCount = this.getTotalCount();
    const percentage = (count / totalCount) * 100;
    return percentage + '%';
  }

  getColorIndex(index: number) {
    return index % 5;
  }

  getTotalCount() {
    return this.departamentLabel.reduce(
      (total, department) => total + department.count,
      0
    );
  }

  clearCharts() {
    document.getElementById('transactionsMonthly').innerHTML = '';
    document.getElementById('orderStatus').innerHTML = '';
    document.getElementById('labelsByDept').innerHTML = '';
    document.getElementById('aiInteractionsByWorkload').innerHTML = '';
    this.chart3Empty = false;
    this.chart4Empty = false;
    this.chart5Empty = false;
    this.chart7Empty = false;
    this.chart10Empty = false;
    this.chartInstances.forEach((chart) => {
      chart.destroy();
    });
    this.chartInstances = [];
  }

  syncUp() {
    this.ngbModalRef = this.modalService.open(PopupDeleteComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.componentInstance.isConfirmAction = true;
    this.ngbModalRef.result.then(
      (result) => {
        this.syncService.syncUp().subscribe((response) => {
          this.syncService.getLastSync().subscribe((res) => {
            this.lastSync = this.formatDate(res?.body?.lastModifiedDate);
          });
          this.syncService.canSync().subscribe((res) => {
            this.canSync = !res.body;
          });
        });
      },
      (err) => {}
    );
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  formatDate(initDate) {
    const date = new Date(initDate);

    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = this.padZero(date.getHours());
    const minutes = this.padZero(date.getMinutes());

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  goToLogsReport() {
    this.router.navigate(['/home/informes/logs']);
  }

  navigateInformes(route: string, filter?: string) {
    window.sessionStorage.setItem('quickCategoryDashboardEvent', 'true');

    switch (filter) {
      case 'externalDelivery':
        window.sessionStorage.setItem('filterForExternalDelivery', 'true');
        if (this.externalDeliveryKpiConfig?.selectedTypes?.length || this.externalDeliveryKpiConfig?.excludedDomains?.length) {
          window.sessionStorage.setItem('externalDeliveryKpiNavFilters', JSON.stringify(this.externalDeliveryKpiConfig));
        }
        break;
      case 'infoLeak':
        window.sessionStorage.setItem('informationLeakEvent', 'true');
        break;
      default:
        break;
    }

    this.router.navigate([`/home/informes/${route}`]);
  }

  navigateIdentifiedAlerts() {
    window.sessionStorage.setItem('quickCategoryDashboardEvent', 'true');
    window.sessionStorage.setItem('informationLeakEvent', 'true');
    if (this.alertKpiActive) {
      window.sessionStorage.setItem('alertKpiNavFilters', JSON.stringify(this.alertKpiConfig));
    }
    this.router.navigate(['/home/informes/dlp']);
  }
}
